{
  "familyId": "TGL-TIJD-DIGITAAL",
  "questions": [
    {
      "id": "TGL-TIJD-DIGITAAL-001",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Hoe laat is 00:00?",
      "options": [
        "middernacht",
        "12 uur 's middags",
        "1 uur 's nachts",
        "24 uur"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_midnight",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 0,
            "minutes": 0
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "24-uurs notatie",
            "content": "Bij de 24-uurs klok begint de dag bij 00:00 (middernacht). Dan tellen we verder: 01:00, 02:00, tot 12:00 (middag). Daarna gaat het door: 13:00, 14:00, tot 23:59. Dan begint de nieuwe dag weer bij 00:00."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij de 24-uurs klok begint de dag bij 00:00. Stap 1: 00 uur = het begin van een nieuwe dag. Stap 2: 00 minuten = precies op het hele uur. Stap 3: 00:00 = middernacht. De dag loopt van 00:00 tot 23:59, daarna begint een nieuwe dag weer bij 00:00.",
        "distractorExplanations": {
          "0": "Correct! 00:00 = middernacht, het begin van een nieuwe dag.",
          "1": "Veelgemaakte fout: middernacht verwarren met 12 uur 's middags. 12:00 is midden op de dag (12 uur na middernacht). Middernacht = 00:00 (begin van de dag). Het verschil: 12:00 − 00:00 = 12 uur.",
          "2": "Veelgemaakte fout: middernacht verwarren met 1 uur 's nachts. 01:00 = 1 uur 's nachts, dat is 1 uur ná middernacht. Middernacht zelf is 00:00.",
          "3": "Veelgemaakte fout: denken dat 24:00 bestaat als tijdnotatie. Op de 24-uurs klok schrijven we nooit 24:00. Na 23:59 springt de klok naar 00:00 (een nieuwe dag begint)."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-002",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je '10 uur 's avonds' digitaal?",
      "options": [
        "22:00",
        "10:00",
        "20:00",
        "12:00"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_evening",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 22,
            "minutes": 0
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Avondtijden omrekenen",
            "content": "Bij tijden 's avonds tel je 12 uur bij het gewone uur. 10 uur 's avonds = 10 + 12 = 22:00. Andersom: trek 12 af om terug te rekenen. 22:00 - 12 = 10 uur 's avonds."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij tijden 's avonds tel je 12 uur bij het gewone uur op. Stap 1: het is 10 uur 's avonds. Stap 2: 10 + 12 = 22. Stap 3: 10 uur 's avonds = 22:00.",
        "distractorExplanations": {
          "0": "Correct! 10 uur 's avonds = 10 + 12 = 22:00.",
          "1": "Veelgemaakte fout: vergeten 12 uur bij te tellen. 10:00 is 10 uur 's ochtends. Voor 's avonds moet je 12 uur bijtellen: 10 + 12 = 22:00.",
          "2": "Veelgemaakte fout: het verkeerde uur omrekenen. 20:00 = 8 uur 's avonds (8 + 12 = 20). Maar 10 uur 's avonds = 10 + 12 = 22:00.",
          "3": "Veelgemaakte fout: 12:00 verwarren met 's avonds. 12:00 is 12 uur 's middags (midden op de dag). Voor 10 uur 's avonds: 10 + 12 = 22:00."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-003",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je '3 uur 's middags' op de digitale klok?",
      "options": [
        "15:00",
        "03:00",
        "13:00",
        "16:00"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_afternoon",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 15,
            "minutes": 0
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Middagtijden omrekenen",
            "content": "Na 12 uur 's middags tel je 12 uur bij het gewone uur. 1 uur 's middags = 13:00, 2 uur 's middags = 14:00, 3 uur 's middags = 15:00, enzovoort."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij tijden 's middags tel je 12 uur bij het gewone uur op. Stap 1: het is 3 uur 's middags. Stap 2: 3 + 12 = 15. Stap 3: 3 uur 's middags = 15:00.",
        "distractorExplanations": {
          "0": "Correct! 3 uur 's middags = 3 + 12 = 15:00.",
          "1": "Veelgemaakte fout: vergeten 12 uur bij te tellen. 03:00 is 3 uur 's ochtends. Voor 's middags moet je 12 uur bijtellen: 3 + 12 = 15:00.",
          "2": "Veelgemaakte fout: het verkeerde uur omrekenen. 13:00 = 1 uur 's middags (1 + 12 = 13). Maar 3 uur 's middags = 3 + 12 = 15:00.",
          "3": "Veelgemaakte fout: er 1 uur naast zitten. 16:00 = 4 uur 's middags (4 + 12 = 16). Maar de vraag gaat over 3 uur 's middags: 3 + 12 = 15:00."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-004",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Wat betekent 18:30?",
      "options": [
        "half 7 's avonds",
        "half 7 's ochtends",
        "half 6 's avonds",
        "6 uur 's avonds"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_evening",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 18,
            "minutes": 30
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Digitaal naar analoog",
            "content": "Trek 12 af van tijden boven de 12:00. 18:30 - 12 = 6:30. Dat is half 7 's avonds. Let op: bij 'half' kijk je naar het volgende uur (6:30 = half 7)."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek 12 af van tijden boven 12:00 om het 'gewone' uur te vinden, en vertaal de minuten naar 'half/kwart'. Stap 1: 18 − 12 = 6, dus het is 6 uur 's avonds. Stap 2: :30 = half uur. Stap 3: bij 'half' kijk je naar het volgende uur: 6:30 = half 7 's avonds.",
        "distractorExplanations": {
          "0": "Correct! 18:30 = 6:30 's avonds = half 7 's avonds.",
          "1": "Veelgemaakte fout: 's avonds en 's ochtends verwarren. Tijden boven 12:00 zijn altijd 's middags of 's avonds. 18:30 is 's avonds (18 − 12 = 6:30 's avonds).",
          "2": "Veelgemaakte fout: 'half' verkeerd vertalen. Bij 'half' kijk je naar het volgende uur. 6:30 = half 7, niet half 6. Onthoud: half 7 = 30 minuten vóór 7 uur.",
          "3": "Veelgemaakte fout: de minuten negeren. :30 betekent half uur (30 minuten). 18:30 is niet 6 uur precies, maar half 7 's avonds."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-005",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Hoe laat is het als de digitale klok 14:45 aangeeft?",
      "options": [
        "kwart voor 3 's middags",
        "kwart over 2 's middags",
        "kwart voor 2 's middags",
        "kwart over 3 's middags"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_quarter",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 14,
            "minutes": 45
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kwart voor aflezen",
            "content": "14:45 betekent 14 - 12 = 2:45. Bij :45 (kwart voor) kijk je naar het volgende uur. 2:45 = kwart voor 3 's middags."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek 12 af van tijden boven 12:00 en vertaal de minuten naar 'kwart over/kwart voor'. Stap 1: 14 − 12 = 2, dus het is 2 uur 's middags. Stap 2: :45 = kwart voor. Stap 3: bij 'kwart voor' kijk je naar het volgende uur: 2:45 = kwart voor 3 's middags.",
        "distractorExplanations": {
          "0": "Correct! 14:45 = 2:45 's middags = kwart voor 3 's middags.",
          "1": "Veelgemaakte fout: kwart over en kwart voor verwarren. :45 = kwart voor (45 minuten), :15 = kwart over (15 minuten). 14:45 is kwart voor 3, niet kwart over 2.",
          "2": "Veelgemaakte fout: 'kwart voor' verkeerd vertalen. Bij 'kwart voor' kijk je naar het volgende uur. 2:45 = kwart voor 3, niet kwart voor 2.",
          "3": "Veelgemaakte fout: kwart over en kwart voor omdraaien. :45 = kwart voor het volgende uur, :15 = kwart over het huidige uur. 14:45 = kwart voor 3, niet kwart over 3."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-006",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je 'half 9 's ochtends' op de digitale klok?",
      "options": [
        "08:30",
        "09:30",
        "20:30",
        "21:30"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_morning_half",
      "variantIndex": 6,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 8,
            "minutes": 30
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Half uur omrekenen",
            "content": "Bij 'half' kijk je naar het vorige uur. Half 9 betekent 8:30 (een half uur voor 9 uur). 's Ochtends hoef je geen 12 bij te tellen, dus het blijft 08:30."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij 'half' kijk je naar het vorige uur. Stap 1: half 9 = een half uur vóór 9 uur = 8:30. Stap 2: 's ochtends hoef je geen 12 bij te tellen. Stap 3: het antwoord is 08:30.",
        "distractorExplanations": {
          "0": "Correct! Half 9 's ochtends = 08:30.",
          "1": "Veelgemaakte fout: bij 'half' naar het volgende uur kijken in plaats van het vorige. Half 9 = 8:30 (een half uur vóór 9), niet 9:30 (een half uur ná 9).",
          "2": "Veelgemaakte fout: 12 uur bijtellen terwijl het 's ochtends is. 20:30 = 8:30 's avonds. De vraag gaat over 's ochtends, dus het blijft 08:30.",
          "3": "Veelgemaakte fout: twee fouten tegelijk — 'half' verkeerd vertalen én 12 uur bijtellen. 21:30 = 9:30 's avonds. Half 9 's ochtends = 08:30."
        }
      }
    },
    {
      "id": "TGL-TIJD-DIGITAAL-007",
      "familyId": "TGL-TIJD-DIGITAAL",
      "module": "TGL",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "ordering",
      "question": "Zet deze tijden op volgorde van vroeg naar laat.",
      "options": [
        "14:30",
        "09:15",
        "16:45",
        "11:00"
      ],
      "correctAnswer": 0,
      "data": {
        "items": ["14:30", "09:15", "16:45", "11:00"],
        "correctOrder": [1, 3, 0, 2]
      },
      "conceptId": "time_ordering",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tijden vergelijken",
            "content": "Kijk eerst naar het uur (het getal voor de dubbele punt). Het laagste uur is het vroegst. Als het uur gelijk is, kijk je naar de minuten. De juiste volgorde is: 09:15, 11:00, 14:30, 16:45."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: vergelijk de uren (het getal vóór de dubbele punt) van laag naar hoog. Stap 1: zoek het laagste uur: 09:15 (9 uur). Stap 2: dan 11:00 (11 uur). Stap 3: dan 14:30 (14 uur). Stap 4: dan 16:45 (16 uur). Volgorde: 09:15 < 11:00 < 14:30 < 16:45."
      }
    }
  ]
}